import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, Fragment, useState } from "react";
import { Button, Form, FormControl, InputGroup, Modal, Spinner } from "react-bootstrap";
import TrackingUnit, { ITrackingUnitResource } from "../../models/trackingUnit";

interface Props {
  trackingUnit: ITrackingUnitResource;
  onUpdated: (trackingUnit: ITrackingUnitResource) => void;
}

const UnassignVehicle: React.FC<Props> = ({
  trackingUnit,
  onUpdated,
}) => {
  const [loading, setLoading] = useState(false);
  const [shown, setShown] = useState(false);

  const saveChanges = async () => {
    try {
      setLoading(true);
      await TrackingUnit.UnassignVehicle(trackingUnit);
      setLoading(false);
      setShown(false);
      if (onUpdated) {
        onUpdated({ ...trackingUnit, vehicle: undefined });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const formSubmit = async (event: FormEvent) => {
    event.preventDefault();
    await saveChanges();
  };

  return (
    <Fragment>
      <button title="Fjern fra køretøj" className="blank-button" onClick={() => setShown(true)}>
        <FontAwesomeIcon icon={faMinus} />
      </button>
      <Modal show={shown} onHide={() => setShown(false)}>
        <form onSubmit={formSubmit}>
          <Modal.Header>Fjern enhed fra køretøj</Modal.Header>
          <Modal.Body>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Køretøj</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  readOnly={true}
                  defaultValue={
                    trackingUnit.vehicle?.alias ||
                    trackingUnit.vehicle?.licensePlate
                  }
                />
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" disabled={loading} type="submit">
              Fjern {loading && <Spinner animation="border" size="sm" />}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setShown(false);
              }}
            >
              Luk
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

export default UnassignVehicle;
